import { useTheme } from '@mui/material';
import {
  ContactForm,
  Link,
  NameBanner,
} from '@rumblefish/ui/src/components/Rumblefish23Theme';
import { type FC } from 'react';
import { StyledSection } from '../styles';
import type { ClickableSubtitleProps, ContactProps } from './Contact.types';
import {
  Subtitle,
  StyledWrapper,
  Title,
  InfoStack,
  ContentStack,
  SubtitleLink,
} from './styles';

type PaletteColors = {
  [key: string]: {
    PLUS_1?: string;
    PLUS_2?: string;
  };
};

export const ClickableSubtitle = ({
  children,
  color,
  link,
}: ClickableSubtitleProps) => {
  const theme = useTheme();

  const palette = theme.palette as unknown as PaletteColors;
  const linkColor = palette?.[`${color}Colors`]?.PLUS_2;
  return (
    <Link to={link}>
      <SubtitleLink color={linkColor} variant="regular_300">
        {children}
      </SubtitleLink>
    </Link>
  );
};

export const Contact: FC<ContactProps> = ({
  id,
  title,
  subtitle,
  color,
  jobTitle,
}) => {
  return (
    <StyledSection width="normal" borderTopOn={!jobTitle} id={id}>
      <StyledWrapper>
        <NameBanner type="section" text={`Let's collaborate`} color={color} />
        <ContentStack>
          <InfoStack>
            {title ? (
              <Title variant="display_md">{title}</Title>
            ) : (
              <Title variant="display_md">
                Let’s work
                <br /> together!
              </Title>
            )}

            {subtitle ? (
              <Subtitle
                variant="regular_500"
                width={{ xs: '100%', md: '50%', xl: '45%' }}>
                {subtitle}
              </Subtitle>
            ) : (
              <Subtitle
                variant="regular_500"
                width={{ xs: '100%', md: '50%', xl: '45%' }}>
                Don’t see a suitable position? We’re always looking for talent,
                so feel free to get in touch!
              </Subtitle>
            )}

            <Subtitle variant="regular_300">
              Do you prefer e-mail?
              <br />
              <ClickableSubtitle
                color={color}
                link={'mailto:jobs@rumblefish.pl'}>
                jobs@rumblefish.pl
              </ClickableSubtitle>
            </Subtitle>
          </InfoStack>
          <ContactForm
            color={color}
            isCareersPage={true}
            emailSubject={
              jobTitle ? `Job Application - ${jobTitle}` : 'Job Application'
            }
          />
        </ContentStack>
      </StyledWrapper>
    </StyledSection>
  );
};
